import { CSSRuleObject } from 'tailwindcss/types/config';

/**
 * Just export your **static** utilities from this file, and you're good to go.
 * Each utility should match Tailwind's {@link CSSRuleObject}.
 *
 * Review the Tailwind documentation to learn how to write static utilities in JS:
 * https://tailwindcss.com/docs/plugins#static-utilities
 */

// TODO: Document utilities in storybook.

export const hideScrollbar: CSSRuleObject = {
  '.scrollbar-hidden': {
    scrollbarWidth: 'none',
    '-ms-overflow-style': 'none',
    '&::-webkit-scrollbar': {
      width: '0',
      height: '0',
    },
  },

  '.scrollbar-visible': {
    scrollbarWidth: 'auto',
    '-ms-overflow-style': 'auto',
    '&::-webkit-scrollbar': {
      width: 'auto',
      height: 'auto',
    },
  },
};

export const breakout: CSSRuleObject = {
  '.breakout': {
    width: 'calc(100vw - var(--compass-breakout-scrollbar-width, 0px))',
    marginLeft: 'calc(-50vw + 50% + (var(--compass-breakout-scrollbar-width, 0px)) / 2)',
  },
}

export const msReveal: CSSRuleObject = {
  '.ms-reveal-hidden': {
    '&::-ms-reveal': {
      display: 'none',
    },
  },

  '.ms-reveal-visible': {
    '&::-ms-reveal': {
      display: 'block',
    },
  }
}
